import { PartnersEnum } from '../enums'
import { partners } from '../helpers/mappings/partners.mapping'

export const partnerIntegrationCode = Object.fromEntries(
  Object.entries(PartnersEnum).map(([key, value]) => [key, value as number]),
)

export const IntegrationData = Object.entries(partnerIntegrationCode).map(([key, id]) => {
  const partnerData = partners.get(Number(id))
  return {
    id,
    name: partnerData?.name || key,
    icon: partnerData?.icon || '',
  }
})
